// extracted by mini-css-extract-plugin
export default {"TextBox":"TextBox_TextBox__mDCnz","TextBoxContainer":"TextBox_TextBoxContainer__T4BIb"};